module.exports = __webpack_public_path__ + "img/scrum-vision-small.8a9e26ff.png";